import React from 'react';
import type {CourseDefinitionResponse} from 'src/api/ProactApiClient';
import {CourseQuizResultsTab} from './CourseQuizResultsTab/CourseQuizResultsTab';

export interface ResultsTabProps {
  course: CourseDefinitionResponse;
}

/**
 * Results tab: quiz-level statistics for the course. The per-assignee roster
 * moved to its own Roster tab (between Assign and Classes).
 */
export const ResultsTab: React.FC<ResultsTabProps> = ({course}) => {
  return <>{course.id && <CourseQuizResultsTab courseId={course.id} />}</>;
};
